import styled from "styled-components";
import { SubHeadingStyled } from "../../styled/Elements";
import { useTranslation } from "react-i18next";
import { RightArrowWhite } from "../../styled/AllImages";
import DynamicTableActionBtns from "./components/DynamicTableActionBtns";

const DynamicTableList = ({
  fields,
  register,
  cols,
  remove,
  readOnly = false,
  setValue,
  getValues,
  watch,
  setShowSelectProductModal,
  setShowSelectCategoryModal,
  handleAddItemRow,
  setEditingRowIndex,
  recalculateRow,
  setCurrentProduct,
}) => {
  const { t, i18n } = useTranslation();
  const watchedProducts = watch ? watch("products") : [];

  const textCenterConstants = ["no", "quantity", "unit_price", "subtotal"];
  const currentRow = watch ? watch("current_input_row") : {};

  const isInputRowEmpty =
    !currentRow?.category && !currentRow?.product && !currentRow?.quantity;

  return (
    <TableWrapper readOnly={readOnly}>
      <HeaderRow>
        <SubHeadingStyled size="20px" weight="700" color="var(--text)">
          {t("products")}
        </SubHeadingStyled>
        {!readOnly && (
          <AddButton
            disabled={isInputRowEmpty}
            type="button"
            onClick={handleAddItemRow}
          >
            <RightArrowWhite
              className={i18n.language === "en" ? "rtl-flip" : ""}
            />
            {t("add_new_item")}
          </AddButton>
        )}
      </HeaderRow>

      <ScrollContainer>
        <table>
          <thead>
            <tr>
              {cols.map((col, idx) => (
                <th
                  style={{
                    textAlign:
                      textCenterConstants.includes(col.name) && "center",
                  }}
                  key={idx}
                >
                  {t(col.label)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.isArray(fields) &&
              fields.length > 0 &&
              fields?.map((field, index) => (
                <tr key={field.id || index}>
                  {cols?.map((col, colIndex) => (
                    <td
                      style={{
                        textAlign:
                          textCenterConstants.includes(col.name) && "center",
                      }}
                      key={colIndex}
                    >
                      {col?.name === "no" ? (
                        index + 1
                      ) : col.name === "actions" && !readOnly ? (
                        <DynamicTableActionBtns
                          row={field}
                          options={["delete"]}
                          onDelete={() => remove(index)}
                          tooltipData={field.tooltipData}
                        />
                      ) : !readOnly &&
                        ["quantity", "unit_price", "discount"].includes(
                          col.name
                        ) ? (
                        <input
                          // type={"number"}
                          type={col.name === "unit" ? "text" : "number"}
                          {...register(`products.${index}.${col.name}`)}
                          placeholder={t(col.label)}
                          onWheel={(e) => e.currentTarget.blur()}
                          min={0}
                          onChange={(e) => {
                            let newValue = e.target.value;

                            if (newValue < 0) {
                              newValue = 0;
                            }

                            // update current field
                            setValue(
                              `products.${index}.${col.name}`,
                              newValue,
                              { shouldValidate: true, shouldDirty: true }
                            );

                            // recalc all dependent fields
                            const rowData = getValues(`products.${index}`);
                            recalculateRow(index, rowData);

                            // const otherKey =
                            //   col.name === "quantity"
                            //     ? "unit_price"
                            //     : "quantity";
                            // const otherValue =
                            //   getValues(`products.${index}.${otherKey}`) || 0;
                            // const subtotal =
                            //   col.name === "quantity"
                            //     ? parseFloat(newValue || 0) *
                            //       parseFloat(otherValue)
                            //     : parseFloat(otherValue) *
                            //       parseFloat(newValue || 0);

                            // setValue(`products.${index}.${col.name}`, newValue);
                            // setValue(
                            //   `products.${index}.subtotal`,
                            //   subtotal.toFixed(2)
                            // );
                          }}
                        />
                      ) : !readOnly && col.name === "product" ? (
                        <input
                          type="text"
                          readOnly
                          value={field?.[col.name] ?? ""}
                          style={{ cursor: "pointer", backgroundColor: 'var(--bgPrimary)' }}
                          disabled={true}
                          onClick={() => {
                            setEditingRowIndex(index);
                            setCurrentProduct(field?.[col.name]);
                            setShowSelectProductModal(true);
                          }}
                        />
                      ) : !readOnly && col.name === "category" ? (
                        <input
                          type="text"
                          readOnly
                          // value={field[col.name]}
                          disabled={true}
                          value={field?.[col.name] ?? ""}
                          style={{ cursor: "pointer", backgroundColor: 'var(--bgPrimary)' }}
                          onClick={() => {
                            setEditingRowIndex(index);
                            setShowSelectCategoryModal(true);
                          }}
                        />
                      ) : (
                        // watchedProducts?.[index][col?.name] || "0.00"
                        watchedProducts?.[index]?.[col?.name] ??
                        field?.[col?.name] ??
                        "0.00"
                      )}
                    </td>
                  ))}
                </tr>
              ))}

            {/* Row for New Item Input */}
            {!readOnly && (
              <tr>
                {cols?.map((col, idx) => {
                  const val = col?.name ? currentRow?.[col.name] ?? "" : "";

                  if (col?.name === "no") return <td key={idx}></td>;

                  if (col.name === "category") {
                    return (
                      <td key={idx}>
                        <input
                          readOnly
                          name="category"
                          value={val}
                          onClick={() => setShowSelectCategoryModal(true)}
                          placeholder={t("select_category")}
                          style={{ cursor: "pointer" }}
                        />
                      </td>
                    );
                  }

                  if (col.name === "product") {
                    return (
                      <td key={idx}>
                        <input
                          readOnly
                          name="product"
                          value={val}
                          disabled={!currentRow?.category_id}
                          onClick={() => {
                            setCurrentProduct(val);
                            setShowSelectProductModal(true);
                          }}
                          placeholder={t("select_product")}
                          style={{ cursor: "pointer", ...(!currentRow?.category_id && {backgroundColor: "var(--bgPrimary)"}) }}
                        />
                      </td>
                    );
                  }

                  if (
                    ["quantity", "unit_price", "discount"].includes(col.name)
                  ) {
                    return (
                      <td key={idx}>
                        <input
                          name={col.name}
                          type="number"
                          min={0}
                          value={val}
                          onWheel={(e) => e.currentTarget.blur()}
                          onChange={(e) => {
                            let newValue = e.target.value;
                            if (newValue < 0) newValue = 0;

                            const updatedRow = {
                              ...currentRow,
                              [col.name]: newValue,
                            };

                            // run row calculation before adding
                            recalculateRow("current_input_row", updatedRow);
                          }}
                          placeholder={t(col.label)}
                        />
                      </td>
                    );
                  }

                  // Show calculated fields (live preview before adding row)
                  if (
                    ["subtotal", "vat", "net_total", "total"].includes(col.name)
                  ) {
                    return (
                      <td key={idx}>
                        {currentRow?.[col.name] ? currentRow[col.name] : "0.00"}
                      </td>
                    );
                  }

                  return (
                    <td key={idx}>
                      {currentRow?.[col.name] ? currentRow[col.name] : ""}
                    </td>
                  );
                })}
              </tr>
              // <tr>
              //   {cols?.map((col, idx) => {
              //     const val = col?.name ? currentRow?.[col.name] ?? "" : "";

              //     if (col?.name === "no") return <td key={idx}></td>;

              //     if (col.name === "category") {
              //       return (
              //         <td key={idx}>
              //           <input
              //             readOnly
              //             name="category"
              //             value={val}
              //             onClick={() => setShowSelectCategoryModal(true)}
              //             placeholder={t("select_category")}
              //             style={{ cursor: "pointer" }}
              //           />
              //         </td>
              //       );
              //     }

              //     if (col.name === "product") {
              //       return (
              //         <td key={idx}>
              //           <input
              //             readOnly
              //             name="product"
              //             value={val}
              //             onClick={() => setShowSelectProductModal(true)}
              //             placeholder={t("select_product")}
              //             style={{ cursor: "pointer" }}
              //           />
              //         </td>
              //       );
              //     }

              //     if (col.name === "quantity") {
              //       return (
              //         <td key={idx}>
              //           <input
              //             name="quantity"
              //             type="number"
              //             onWheel={(e) => e.currentTarget.blur()}
              //             min={0}
              //             value={val}
              //             onChange={(e) => {
              //               let quantity = e.target.value;

              //               if (quantity < 0) quantity = 0;
              //               const unit_price = currentRow.unit_price || 0;
              //               const subtotal =
              //                 quantity && unit_price
              //                   ? parseFloat(quantity) * parseFloat(unit_price)
              //                   : "";

              //               setValue("current_input_row", {
              //                 ...currentRow,
              //                 quantity,
              //                 subtotal,
              //               });
              //             }}
              //             placeholder={t("quantity")}
              //           />
              //         </td>
              //       );
              //     }

              //     if (col.name === "unit_price" || col.name === "subtotal") {
              //       return <td key={idx}>{val}</td>;
              //     }

              //     return <td key={idx}></td>;
              //   })}
              // </tr>
            )}
          </tbody>
        </table>
      </ScrollContainer>
    </TableWrapper>
  );
};

export default DynamicTableList;

const TableWrapper = styled.div`
  margin-top: 1rem;
  background-color: var(--bgPrimary);
  padding: 25px;
  padding-bottom: 25px;
  border-radius: 15px;

  .rtl-flip {
    transform: scaleX(-1);
    transition: transform 0.3s ease;
  }

  table {
    min-width: 800px;
    width: ${({ readOnly }) => (readOnly ? "100%" : "100%")};
    border-collapse: collapse;
    margin-top: 1rem;
    color: var(--text);
  }

  tbody tr:not(:last-child) {
    border-bottom: 1px solid var(--border);
  }

  tbody {
    background-color: #fff;
    overflow: auto;
  }

  td:first-child {
    width: 90px !important;
  }

  td {
    background-color: #fff;
    max-width: 140px;
    width: auto;
  }

  th,
  td {
    border: none;
    padding: 10px;
    text-align: left;
  }

  th {
    background-color: var(--lightGrayBg);
    color: var(--text);
    font-size: 16px;
    font-weight: 600;
  }

  thead tr th:first-child {
    border-top-left-radius: 15px;
  }

  thead tr th:last-child {
    border-top-right-radius: 15px;
  }
  tbody tr:last-child td:first-child {
    border-bottom-left-radius: 15px;
  }

  tbody tr:last-child td:last-child {
    border-bottom-right-radius: 15px;
  }

  /* td:nth-of-type(5) input {
    border: none !important;
  } */

  input {
    width: 100%;
    min-width: 100px;
    max-width: 100%;
    padding: 8px 12px;
    border: 1px solid var(--border);
    border-radius: 4px;
    background: none;
    color: var(--text);
    font-size: 14px;
    box-sizing: border-box;
    outline: none;
    box-shadow: none;

    &:focus,
    &:hover,
    &:active {
      outline: none !important;
      box-shadow: none !important;
      background: none;
    }

    &::placeholder {
      color: var(--text2, #aaa);
    }
  }
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AddButton = styled.button`
  padding: 8px 16px;
  background-color: var(--themeColor);
  color: white;
  border: none;
  display: flex;
  gap: 10px;
  align-items: center;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    /* background-color: var(--themeColorDark, #333); */
  }

  &:disabled {
    opacity: 0.5;
  }
`;

const ScrollContainer = styled.div`
  overflow-x: auto;
  width: 100%;
  &::-webkit-scrollbar {
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--text2);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--themeColor);
  }
`;
